<template>
  <div class="blue_loader"></div>
</template>

<script>
export default {
  name: "InputLoader"
};
</script>

<style lang="scss" scoped>
.blue_loader {
  width: 20px;
  height: 20px;
  border-left: 5px solid #5099de;
  border-top: 5px solid #5099de;
  border-right: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-radius: 60px;
  animation: spin 0.3s infinite linear;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
